<template>
  <div>
    <file-form-field
      ref="uploader"
      :label="label"
      multiple
      @input="add(...$event)">
    </file-form-field>
    <slot name="advice"></slot>
    <data-table
      ref="dt"
      v-if="value && value.length"
      class="mt-4"
      :columns="columns"
      :value="value"
    />
    <div class="text-right" v-if="value.length">
      <b-button
        variant="danger"
        @click.prevent="clear()">
        <i class="fa fa-fw fa-times"></i>
        Elimina tutti
      </b-button>
      <b-button
        variant="success"
        @click.prevent="upload()">
        <i class="fa fa-fw fa-upload"></i>
        Carica tutti
      </b-button>
    </div>
  </div>
</template>
<script>
import { uuid, isSameFile, renameFile } from 'core/utils';
import FileUtilsMixin from 'vue-core/mixins/FileUtilsMixin';

export default {
  mixins: [ FileUtilsMixin ],

  props: {
    restrict: {
      type: String,
      default: undefined
    },

    label: {
      type: String,
      default: undefined
    },

    value: {
      type: Array,
      default: () => []
    },

    customColumns: {
      type: Array,
      default: () => []
    },

    customActions: {
      type: Function,
      default: () => []
    },

    /**
     * Returns error string
     */
    validateFile: {
      type: Function,
      default: (/*file*/) => undefined
    }
  },

  data() {
    return {
      progress: {}
    };
  },

  created() {
    const progress = (item /*, index*/) => [
      {
        condition: () => !this.getError(item) && !this.validateFile(item),
        type: 'progress',
        value: () => this.getProgress(item),
      },
      {
        condition: () => this.getError(item) || this.validateFile(item),
        value: () => this.getError(item) || this.validateFile(item),
        class: 'text-danger'
      }
    ];

    /*
    this.columns = [
      { label: 'Azioni', type: 'actions', actions },
      { label: 'Nome'      , value: (item) => item.name },
      { label: 'Dimensione', value: (item) => item.size, type: 'filesize' },
      { label: 'Tipo'      , value: (item) => item.type },
      { label: 'Progresso' , type: 'conditions', conditions: progress }
    ];
    */

    this.columns = [
      {
        //label: 'Nome',
        class: 'col-12 font-weight-bold',
        value: (item) => item.name
      },
      {
        //label: 'Progresso',
        class: 'col-12',
        type: 'conditions',
        conditions: progress
      },
      ...this.customColumns,
      {
        //label: 'Dimensione',
        class: 'col-6',
        value: (item) => item.size,
        type: 'filesize'
      },
      {
        //label: 'Azioni',
        class: 'col-6 text-right',
        type: 'actions',
        actions: (item, index) => [
          {
            icon: 'times',
            buttonClass: 'text-danger pl-0',
            exec: () => this.remove(index)
          },
          {
            icon: 'pencil',
            buttonClass: 'text-warning pl-0',
            exec: () => this.rename(index)
          },
          ...this.customActions(item, index),
          {
            icon: 'upload',
            buttonClass: 'text-success pl-0',
            exec: () => this.upload(index),
            disabled: () => !!this.validateFile(item)
          },
        ]
      },
    ];
  },

  methods: {
    getProgress(file) {
      if (!this.progress || !this.progress[file.id]) {
        return 0;
      }
      return this.progress[file.id].percentage;
    },

    getError(file) {
      if (!this.progress || !this.progress[file.id]) {
        return undefined;
      }
      const error = this.progress[file.id].error;
      return error && error.message;
    },

    setProgress(file, loaded, total) {
      const percentage = loaded * 100 / total;
      const progress = { ...this.progress };
      progress[file.id] = { loaded, total, percentage };
      this.progress = progress;
    },

    setError(file, error) {
      const progress = { ...this.progress };
      progress[file.id] = { error };
      this.progress = progress;
    },

    accept(file) {
      if (this.restrict) {
        const extensions = this.restrict.split(',')
            .map(x => {
              let ret = x.trim().toLowerCase();
              if (ret.startsWith('*.')) {
                ret = ret.substring(2);
              }
              return ret;
            });
        for (let e of extensions) {
          if (file.name.toLowerCase().endsWith(e)) {
            return true;
          }
        }
        return false;
      }
      return true;
    },

    reset() {
      this.$refs.uploader.reset();
    },

    add(...files) {
      if (!files || files.length < 1) {
        this.$emit('input', this.value);
        this.reset();
        return;
      }
      const newFiles = [ ...this.value ];
      for (let file of files) {
        if (this.accept(file) && !newFiles.find(f => isSameFile(file, f))) {
          file.id = uuid();
          newFiles.push(file);
        }
      }
      this.reset();
      this.$emit('input', newFiles);
    },

    clear() {
      this.$emit('input', []);
    },

    remove(index) {
      const value = [ ...this.value ];
      value.splice(index, 1);
      this.$emit('input', value);
    },

    rename(index) {
      const oldName = this.value[index].name;
      let newName = prompt("Rinomina file:", oldName);
      if (newName) {
        newName = newName.trim();
        if (newName) {
          const value = [ ...this.value ];
          const properties = { ...value[index] };
          value[index] = renameFile(value[index], newName);
          for (let k in properties) {
            value[index][k] = properties[k];
          }
          this.$emit('input', value);
        }
      }
    },

    upload(index) {
      if (index === undefined) {
        this.$emit('upload', this.value);
      } else {
        this.$emit('upload', [ this.value[index] ]);
      }
    }
  }
};
</script>
